<template>
  <SimonModal
    is-visible
    customModalClass="mfa-hotline-modal"
    :btn-right-title="getSlotText('btnClose')"
    @hide="emitClose"
  >
    <template v-slot:modalTitle>
      <h3>
        <slot name="txtHeadline"></slot>
      </h3>
    </template>
    <div class="mfa-hotline-modal--group">
      <span class="mfa-hotline-modal--desc">
        <slot name="txtDescription"></slot>
      </span>
      <img aria-hidden="true" class="hotline-icon" alt="hotline" src="/files/flash/images/svg-icons/headset.svg"/>
      <a :href="`tel:${hotlineNumber}`" class="hotline-phone">
        <slot name="txtHotlineNumber"></slot>
      </a>
    </div>
  </SimonModal>
</template>

<script>
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'MfaHotline',
  components: { SimonModal },
  props: [],
  computed: {
    hotlineNumber () {
      return this.getSlotText('txtHotlineNumber')
    }
  },
  methods: {
    emitClose () {
      this.$emit('close')
    }
  }
}
</script>
